<template>
  <div>
    <div class="datepicker-dropdown">
      <button type="button" class="datepicker-dropdown__header">
        <div
          v-if="!disabled"
          class="datepicker-dropdown__header-button"
          @click="showPrev(options)"
          :class="{ hidden: !isShowPrevButton }"
        >
          <icon class="_active" name="arrow-down_grey" />
        </div>
        {{ placeholder }}
        <div
          v-if="!disabled"
          class="datepicker-dropdown__header-button"
          @click="showNext(options)"
          :class="{ hidden: !isShowNextButton }"
        >
          <icon name="arrow-down_grey" />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DatePickerHeader",

  props: {
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "Поле"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: this.$props.value,
      isVisible: false,
      index: 0
    };
  },

  computed: {
    selectedOption() {
      return this.options.find(option => option.selected);
    },
    placeholder() {
      return this.selectedOption?.label || this.$props.title;
    },
    isShowPrevButton() {
      if (!this.selectedOption) return false;
      return this.options.find(option =>
        this.selectedOption.value === 0
          ? option.value === 11 && option.year < this.selectedOption.year
          : option.value < this.selectedOption.value &&
            option.year === this.selectedOption.year
      );
    },
    isShowNextButton() {
      if (!this.selectedOption) return false;
      return this.options.find(option =>
        this.selectedOption.value === 11
          ? option.value === 0 && option.year > this.selectedOption.year
          : option.value > this.selectedOption.value &&
            option.year === this.selectedOption.year
      );
    }
  },

  methods: {
    toggleVisibility(visibility = !this.isVisible) {
      this.isVisible = visibility;
    },
    showPrev() {
      let index = this.options.findIndex(item => item.selected === true);
      index = index <= 0 ? 0 : index - 1;
      this.selectOption(index);
    },
    showNext() {
      this.selectOption(
        this.options.findIndex(item => item.selected === true) + 1
      );
    },
    selectOption(index) {
      this.options = this.options.map((option, i) => {
        return { ...option, selected: i === index };
      });
      this.$emit("input", this.options);
    }
  }
};
</script>

<style lang="scss" scoped>
.datepicker-dropdown {
  position: relative;

  &__header {
    width: 100%;

    padding: 0 15px;

    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    color: #6d7179;

    display: flex;
    justify-content: space-between;
    align-items: center;

    background: none;
    border: none;
    outline: none;

    cursor: pointer;
    &-button {
      display: flex;
      padding: 10px;
      transform: rotate(-90deg);
    }
    & .hidden {
      opacity: 0;
      pointer-events: none;
    }
    .svg-icon {
      width: 16px;
      height: 16px;

      &._active {
        transform: rotate(-180deg);
      }
    }
  }

  &__content {
    border-radius: 2px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);

    max-height: 160px;
    overflow-y: scroll;

    position: absolute;
    top: 45px;
    left: 0;

    width: 100%;

    z-index: 1;

    &-item {
      display: block;

      width: 100%;

      text-align: left;

      height: 40px;
      line-height: 40px;

      padding: 0 15px;

      color: #000;

      transition: all 0.3s;

      background: #fff;
      border: none;
      outline: none;

      cursor: pointer;

      &:hover,
      &._active {
        background: #009ee3;
        color: #fff;
      }
    }
  }

  &__disabled {
    cursor: inherit;
  }
}
</style>
